<div class="accounts">
  <ng-template #bottomSheetContent>
    <app-add-bank-account></app-add-bank-account>
  </ng-template>

  <div class="add-account">
    <h4>Contas adicionadas</h4>
    <span class="tappable" (click)="openAddBankAccountModal()"
      >Adicionar conta</span
    >
  </div>
  <div *ngIf="bankAccounts && bankAccounts.length > 0">
    <div *ngFor="let account of bankAccounts" class="account-card">
      <div class="account-info">
        <mat-icon class="bank-icon">account_balance</mat-icon>
        <span class="bank-details p-text-grey-dark text-center">{{
          account.bank
        }}</span>
        <span class="agency-details p-text-grey"
          >Agência {{ account.agency }}</span
        >
        <span class="account-details p-text-grey"
          >Conta {{ account.number }}</span
        >
      </div>
      <span *ngIf="account.isDefault" class="default-account-chip"
        >Conta padrão</span
      >
      <ng-container *ngIf="!account.isDefault">
        <mat-icon [matMenuTriggerFor]="beforeMenu" class="more-options"
          >more_vert</mat-icon
        >
        <mat-menu class="my-menu" #beforeMenu="matMenu" xPosition="before">
          <div class="download-document">
            <span (click)="setDefaultBankAccount(account.id)"
              >Tornar conta padrão</span
            >
          </div>
          <button mat-menu-item class="custom-button">
            <div (click)="deleteBankAccount(account.id)" class="icon-and-image">
              <img src="assets/icons/trash-icon.svg" />

              <span> Remover </span>
            </div>
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </div>
</div>
